import { useState, Fragment } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Checkbox } from "@mui/material";
import { displayCost, displayDateFormatter } from "./helper";

function Row({ row, selChargeEntries, setSelChargeEntries, isCompletePay }) {
  const [open, setOpen] = useState(false);
  const isSelected = selChargeEntries.includes(row.charge_entry_id);
  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <Checkbox
            checked={isSelected}
            color="secondary"
            disabled={isCompletePay || row.status === "Bill Paid"}
            onClick={(e) => {
              if (!e.target.checked) {
                setSelChargeEntries(
                  selChargeEntries.filter((b) => b !== row.charge_entry_id)
                );
              } else {
                setSelChargeEntries([...selChargeEntries, row.charge_entry_id]);
              }
            }}
          />
        </TableCell>

        <TableCell align="center">
          {displayDateFormatter(row.service_date)}
        </TableCell>
        <TableCell align="right">{displayCost(row.billed_amount)}</TableCell>
        <TableCell align="right">{displayCost(row.adj_paid_amount)}</TableCell>
        <TableCell align="right">
          {displayCost(row.total_pending_balance)}
        </TableCell>
        <TableCell align="right">
          {row.status === "Bill Paid"
            ? "Paid"
            : displayCost(isSelected ? row.total_pending_balance : 0)}
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Date of Service</TableCell>
                    <TableCell>Procedure Code</TableCell>
                    {/* <TableCell>Modifier </TableCell> */}
                    <TableCell>Description</TableCell>
                    {/* <TableCell>Units</TableCell> */}
                    <TableCell>Billed Amount</TableCell>
                    <TableCell>Remaining Balance</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.charges?.map((charges) => (
                    <TableRow key={charges.procedure_code}>
                      <TableCell>
                        {displayDateFormatter(charges.service_date_from)}
                      </TableCell>
                      <TableCell>{charges.procedure_code}</TableCell>
                      {/* <TableCell>
                        {[
                          charges.modifier1,
                          charges.modifier2,
                          charges.modifier3,
                          charges.modifier4,
                        ]
                          .filter((x) => x)
                          .join(", ") || "N/A"}
                      </TableCell> */}
                      <TableCell>{charges.description}</TableCell>
                      {/* <TableCell>{charges.units}</TableCell> */}
                      <TableCell>{charges.charge_amt}</TableCell>
                      <TableCell>
                        {displayCost(charges.patient_resp_amt)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}

export default function CollapsibleTable({
  invoice_details,
  selChargeEntries,
  setSelChargeEntries,
  calculated_cost,
  isCompletePay,
  totalAmount,
  transaction_fees,
  amtData,
}) {
  if (!invoice_details) return null;
  console.log("invoice_details", transaction_fees, amtData);
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align="center">DOS</TableCell>
            <TableCell align="right">Total Billed</TableCell>
            <TableCell align="right">Insurance Adjusted / Paid</TableCell>
            <TableCell align="right">Your Responsibility</TableCell>
            <TableCell align="right">Payment</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {invoice_details.map((charge_entry) => (
            <Row
              key={charge_entry.charge_entry_id}
              row={charge_entry}
              selChargeEntries={selChargeEntries}
              setSelChargeEntries={setSelChargeEntries}
              isCompletePay={isCompletePay}
            />
          ))}
          <TableRow>
            <TableCell colSpan={4}>Total</TableCell>
            <TableCell align="right">{displayCost(amtData)}</TableCell>
            <TableCell align="right">{displayCost(calculated_cost)}</TableCell>
            <TableCell />
          </TableRow>
          {transaction_fees !== null ? (
            <>
              <TableRow>
                <TableCell colSpan={4}>Convenience Transaction Fees</TableCell>
                <TableCell align="right"></TableCell>
                <TableCell align="right">{transaction_fees}</TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell colSpan={4}>Total Due</TableCell>
                <TableCell align="right"></TableCell>
                <TableCell align="right">
                  {transaction_fees + amtData}
                </TableCell>
                <TableCell />
              </TableRow>
            </>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
